// extracted by mini-css-extract-plugin
module.exports = {"container":"e_xbb","title":"e_ybb","content":"e_zbb","desktopHeader":"e_Abb"};